import { Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { buildProductMotulImageSrc } from "./productMotulImageUtils";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%"
    },
    previewWrapper: {
        alignItems: "center",
        border: "1px solid #d9d9d9",
        borderRadius: 8,
        display: "flex",
        justifyContent: "center",
        minHeight: 260,
        position: "relative",
        backgroundColor: "#fafafa"
    },
    preview: {
        maxHeight: 240,
        maxWidth: "100%",
        objectFit: "contain"
    },
    navButton: {
        color: "#333"
    },
    deleteButton: {
        backgroundColor: "#fff",
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        zIndex: 1
    },
    thumbnailButton: {
        border: "1px solid #d9d9d9",
        borderRadius: 6,
        cursor: "pointer",
        height: 72,
        overflow: "hidden",
        padding: 0,
        width: "100%"
    },
    thumbnailButtonActive: {
        border: "2px solid var(--primary-color)"
    },
    thumbnailImage: {
        height: "100%",
        objectFit: "cover",
        width: "100%"
    },
    empty: {
        color: "#6b6b6b",
        padding: theme.spacing(2)
    }
}));

const ProductMotulImageCarousel = ({ images, onDelete, isDeleting }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        if (!images?.length) {
            setSelectedIndex(0);
            return;
        }

        if (selectedIndex > images.length - 1) {
            setSelectedIndex(images.length - 1);
        }
    }, [images, selectedIndex]);

    if (!images?.length) {
        return <Typography className={classes.empty}>{t("productMotulImagesEmpty")}</Typography>;
    }

    const currentImage = images[selectedIndex];

    return (
        <div className={classes.root}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={2}>
                    <IconButton
                        className={classes.navButton}
                        onClick={() => setSelectedIndex((selectedIndex - 1 + images.length) % images.length)}
                    >
                        <NavigateBeforeIcon fontSize="large" />
                    </IconButton>
                </Grid>
                <Grid item xs={8}>
                    <div className={classes.previewWrapper}>
                        {onDelete ? (
                            <IconButton
                                className={classes.deleteButton}
                                disabled={isDeleting}
                                onClick={() => onDelete(currentImage)}
                                title={t("productMotulImagesDelete")}
                            >
                                <DeleteIcon />
                            </IconButton>
                        ) : null}
                        <img
                            alt={currentImage.fileName || t("productMotulImagesTitle")}
                            className={classes.preview}
                            src={buildProductMotulImageSrc(currentImage)}
                        />
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <IconButton
                        className={classes.navButton}
                        onClick={() => setSelectedIndex((selectedIndex + 1) % images.length)}
                    >
                        <NavigateNextIcon fontSize="large" />
                    </IconButton>
                </Grid>
            </Grid>

            <Grid container spacing={1} style={{ marginTop: 8 }}>
                {images.map((image, index) => (
                    <Grid item xs={4} sm={2} key={image.id}>
                        <button
                            className={`${classes.thumbnailButton} ${index === selectedIndex ? classes.thumbnailButtonActive : ""}`}
                            onClick={() => setSelectedIndex(index)}
                            type="button"
                        >
                            <img
                                alt={image.fileName || `${t("productMotulImagesTitle")} ${index + 1}`}
                                className={classes.thumbnailImage}
                                src={buildProductMotulImageSrc(image)}
                            />
                        </button>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default ProductMotulImageCarousel;
